// React
import React from 'react';
import classNames from 'classnames';
// Styles
import useStyles from './MenuSearchStateMessage.styles';
import BlueLupeIcon from '../icons/blue-lupe-icon/BlueLupeIcon';

const MenuSearchStateMessage = ({ classes, text }) => {
  const componentClasses = useStyles();
  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <BlueLupeIcon
        classes={{ root: classNames(componentClasses.icon, classes.icon) }}
      />
      <div className={classNames(componentClasses.text, classes.text)}>
        <span>{text}</span>
      </div>
    </div>
  );
};

MenuSearchStateMessage.defaultProps = {
  classes: {},
  text: '',
};

export default MenuSearchStateMessage;
